import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Button } from './ui/button';

const pricingPlans = [
  {
    name: 'Get Started Free',
    description: 'No credit card required',
    features: [
      '3 resume downloads',
      'All template designs',
      'Resume emailed to you instantly',
      'Email support',
    ],
    cta: 'Get Started',
    ctaVariant: 'outline',
    href: '/signup',
  },
  {
    name: 'Need More?',
    description: 'For unlimited resume downloads',
    features: [
      'Unlimited resume downloads',
      'All template designs',
      'Priority support',
      'Custom branding',
    ],
    cta: 'Contact Us',
    ctaVariant: 'primary',
    href: 'https://thirdeyedata.ai/contact-us/',
  },
];

const Pricing = () => {
  return (
    <section id="pricing" className="py-16 sm:py-20 bg-gradient-to-br from-slate-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Simple, Transparent Pricing
          </h2>
          <p className="text-base sm:text-xl text-gray-600 max-w-2xl mx-auto">
            Start for free. Scale when you need to.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 max-w-4xl mx-auto items-stretch">
          {pricingPlans.map((plan, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="relative flex flex-col p-5 sm:p-6 lg:p-8 rounded-2xl border-2 bg-white border-gray-200 shadow-lg"
            >
              <div className="flex-grow">
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900">{plan.name}</h3>
                <p className="mt-2 text-sm sm:text-base text-gray-600">{plan.description}</p>

                <ul className="mt-6 sm:mt-8 space-y-3">
                  {plan.features.map((feature, idx) => (
                    <li key={idx} className="flex gap-x-3">
                      <Check className="h-5 w-5 flex-none text-blue-600 mt-0.5" />
                      <span className="text-sm sm:text-base text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <Button
                onClick={() => { window.location.href = plan.href; }}
                className={`mt-8 w-full ${
                  plan.ctaVariant === 'primary'
                    ? 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white'
                    : 'bg-white border-2 border-gray-300 hover:bg-gray-50 text-gray-900'
                }`}
                size="lg"
              >
                {plan.cta}
              </Button>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing;
